import React from "react";
import "./Input.scss";
import Field from "../Field/Field";

/**
 * Input
 * @param {Object} props
 * @param {String} props.name Field name
 * @param {String} props.label Text label
 * @param {String|Number} props.value Field value
 * @param {Boolean} props.required Whether field is required
 * @param {String} [props.type="number"] Field type
 * @param {String} [props.help] Help text
 * @param {String} [props.prefix] Text prefix before field
 * @param {Function} [props.onInput] Optional callback
 * @returns {React.ReactElement}
 */
function Input({ name, label, value, required, type, help, prefix, onInput }) {
  return (
    <Field {...{ name, label, help }}>
      {prefix ? <span className="Field__prefix">{prefix}</span> : null}
      <input
        className={`Input${prefix ? ` Input--prefixed` : ""}`}
        name={name}
        id={name}
        type={type || "number"}
        defaultValue={value}
        required={required}
        onInput={onInput}
      />
    </Field>
  );
}

export default Input;
